/*
 * Copyright (c) 2021 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import axios, { AxiosRequestConfig, AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import qs from 'query-string';

const FUS_API_ADDR =
    window.env && window.env.FUS_API_ADDR ? window.env.FUS_API_ADDR : 'https://fus.fiscal.noogadev.com/api';

class FusApiClient {
    private axiosInstance: AxiosInstance;

    constructor() {
        this.axiosInstance = axios.create({
            baseURL: FUS_API_ADDR,
            paramsSerializer: (params) => qs.stringify(params),
            headers: {},
        });

        this.initErrorsInterceptor();
    }

    private initErrorsInterceptor(): void {
        this.axiosInstance.interceptors.response.use(null, (err: AxiosError) => {
            return Promise.reject(err);
        });
    }

    public async get<T>(url: string, params?: unknown): Promise<T> {
        const resp = await this.axiosInstance.get<T>(url, { params });
        return resp.data;
    }

    public async getWithFullResponse<T>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
        if (config.headers) {
            config.headers = { ...this.axiosInstance.defaults.headers, ...config.headers };
        }
        return await this.axiosInstance.get<T>(url, config);
    }
}

export const fusApiClient = new FusApiClient();
